import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
    LOADACCESSES = 'react/common/contacts/LOADACCESSES',
    LOADACCESSES_PENDING = 'react/common/contacts/LOADACCESSES_PENDING',
    LOADACCESSES_FULFILLED = 'react/common/contacts/LOADACCESSES_FULFILLED',
    LOADACCESSES_REJECTED = 'react/common/contacts/LOADACCESSES_REJECTED',

    LOADPASSAGES = 'react/common/contacts/LOADPASSAGES',
    LOADPASSAGES_PENDING = 'react/common/contacts/LOADPASSAGES_PENDING',
    LOADPASSAGES_FULFILLED = 'react/common/contacts/LOADPASSAGES_FULFILLED',
    LOADPASSAGES_REJECTED = 'react/common/contacts/LOADPASSAGES_REJECTED',

    // LOADCONTACTACCESSES = 'react/common/contacts/LOADCONTACTACCESSES',
    // LOADCONTACTACCESSES_PENDING = 'react/common/contacts/LOADCONTACTACCESSES_PENDING',
    // LOADCONTACTACCESSES_FULFILLED = 'react/common/contacts/LOADCONTACTACCESSES_FULFILLED',
    // LOADCONTACTACCESSES_REJECTED = 'react/common/contacts/LOADCONTACTACCESSES_REJECTED',
    
    OTHER_ACTION = 'react/common/contacts/__any_other_action__',
}

export type Types = IBaseAction<Keys>;